import type { IntlShape } from 'react-intl'
import type { AccountingSettingHeader, AccountingSettingRow } from './types'

export const accountingSettingHeaders: AccountingSettingHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Osio',
				description: 'Table column header: Section',
			}),
		key: 'section', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tila',
				description: 'Table column header: Status',
			}),
		key: 'status', //TODO:
		show: true,
		type: 'checkbox',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tositelaji',
				description: 'Table column header: Voucher type',
			}),
		key: 'voucherType', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tili',
				description: 'Table column header: Account',
			}),
		key: 'account', //TODO:
		show: true,
		type: 'string',
	},
]

export const accountingSettingRows: AccountingSettingRow[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Laskutus',
				description: 'Table column header: Invoicing',
			}),
		key: 'invoicing', //TODO:
		showAccount: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Suoritukset',
				description: 'Table column header: Payments',
			}),
		key: 'payments', //TODO:
		showAccount: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Ostolaskut',
				description: 'Table column header: Purchase invoices',
			}),
		key: 'purchaseInvoices', //TODO:
		showAccount: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Maksut',
				description: 'Table column header: Dues',
			}),
		key: 'dues', //TODO:
		showAccount: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Kirjanpito',
				description: 'Table column header: Accounting',
			}),
		key: 'accounting', //TODO:
		showAccount: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tuloslaskelma',
				description: 'Table column header: Profit and loss statement',
			}),
		key: 'profitLossStatement', //TODO:
		showAccount: false,
		hideStatus: true,
	},
]
